<template>
  <v-select
    class="g-select cursor-default"
    dense
    flat
    :height="height"
    :menu-props="menuProps"
    v-bind="$attrs"
    v-on="$listeners"
    v-bind:value="value"
  >
    <template v-slot:append>
      <v-icon class="arrow_down" :style="iconUseStyle"></v-icon>
    </template>

    <!-- 점검현황 지역 multi 선택 시, 선택된 지역이 많으면 글자가 영역밖으로 나가서 추가 -->
    <template v-slot:selection="{item, index}" v-if="textOverFlag">
      <slot name="selection" :item="item" :index="index"></slot>
    </template>
    <!-- 데이터 없을 때 -->
    <template #no-data>
      <div class="text-center py-2">{{ $t("texts.selectNoDataText") }}</div>
    </template>
  </v-select>
</template>
<!--  v-bind:value="$attrs.value" -->
<script>
export default {
  name: 'GSelect',
  inheritAttrs: true,
  props: {
    value: {
      required: true
    },
    iconUseStyle: {
      type: String,
      required: false
    },
    menuProps: {
      type: String,
      required: false
    },
    height: {
      type: Number,
      required: false,
      default: 36
    },
    textOverFlag: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>
.g-select.v-text-field:not(.v-text-field--outlined) {margin-top: 0;}
.g-select.v-text-field:not(.v-text-field--outlined) >>> .v-text-field__details {margin-bottom: 8px;}
.g-select.v-text-field--outlined, .g-select.v-text-field--solo {border-radius:3px;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot {background-color: #fff;min-width:95px;}
.theme--dark .g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot {background-color: #1a1d21;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot:hover .v-label.v-label--active {color:#3ba8be !important;}
.g-select.v-input--is-focused.v-text-field--outlined >>> .v-input__control > .v-input__slot .v-label.v-label--active {color:#3ba8be !important;font-weight:bold;}
.g-select.v-text-field--solo >>> .v-input__control > .v-input__slot {border:1px solid #cecece;}
.theme--dark .g-select.v-text-field--solo >>> .v-input__control > .v-input__slot {border:1px solid #363d44;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot {border:0px !important;padding: 0;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot fieldset {border:1px solid #cecece;}
.theme--dark .g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot fieldset {border:1px solid #363d44;}
.g-select.v-text-field--solo >>> .v-input__control > .v-input__slot:hover {border:1px solid #3ba8be;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot:hover {border:0px !important;}
.g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot:hover fieldset {border:1px solid #3ba8be;}
.g-select.v-text-field--solo.v-input--is-focused >>> .v-input__control > .v-input__slot {border: solid 1.5px #3ba8be !important;}
.g-select.v-text-field--outlined.v-input--is-focused >>> .v-input__control > .v-input__slot {border: 0px !important;}
.g-select.v-text-field--outlined.v-input--is-focused >>> .v-input__control > .v-input__slot fieldset {border: solid 1.5px #3ba8be !important;}
.g-select.v-text-field--solo.error--text >>> .v-input__control > .v-input__slot {border:1.5px solid #b71c1c;}
.g-select.v-text-field--outlined.error--text >>> .v-input__control > .v-input__slot {border:0px !important;}
/*.g-select.v-text-field--outlined.error--text >>> .v-input__control > .v-input__slot fieldset {border:1.5px solid #b71c1c;}*/
.g-select.v-text-field--outlined.error--text >>> .v-input__control > .v-input__slot fieldset {border:1px solid #b71c1c;}
.g-select.v-input--is-focused.error--text >>> .v-input__slot {border-color: #b71c1c !important;}
.g-select.v-input--is-focused.error--text.v-text-field--outlined >>> .v-input__slot {border-width: 1.5px;}
.g-select.v-text-field--outlined.error--text >>> .v-input__slot:hover fieldset, .g-select.v-text-field--solo.error--text >>> .v-input__slot:hover {border-color: #b71c1c !important;border-width:1.5px;}

.g-select.v-text-field >>> .v-label {color:#888;}
.theme--dark .g-select.v-text-field >>> .v-label {color:#7a8188;}
.theme--dark .g-form-required .g-select.v-text-field >>> .v-label {color:#2373c4 !important;}

.g-select.v-text-field >>> .v-select__selections {color:#444;}
.theme--dark .g-select.v-text-field >>> .v-select__selections {color:#d9dee4;}

.g-select.v-text-field--outlined >>> .v-input__control .v-select__slot {padding: 0 8px;}
.g-select.v-text-field--outlined.gSelect.mobile >>> .v-input__control .v-select__slot {padding: 0 8px 0 16px;}
.g-select.v-text-field--outlined >>> .v-input__control .v-select__slot .v-label {left: 12px!important;}

.g-select.v-text-field:not(.error--text) >>> .v-input__control:hover .v-select__slot .v-label {color: #3ba8be;}
.g-select.v-text-field.error--text >>> .v-input__control .v-select__slot .v-label {color: #b71c1c!important;}
.g-select.v-text-field.error--text >>> .v-input__control:hover .v-select__slot .v-label {color: #b71c1c!important;}
.g-select.v-text-field.v-text-field--outlined >>> .v-select__slot .v-label:not(.v-label--active) {top: 8px;}
.g-select.v-text-field.v-input--is-focused:not(.error--text) >>> .v-select__slot .v-label {color: #3ba8be!important;font-weight: bold;}
.g-select.v-text-field.v-input--is-focused.error--text >>> .v-select__slot .v-label {color: #b71c1c!important;font-weight: bold;}

.g-select.v-select >>> .v-input__control {min-height:36px;}
.g-select.v-select >>> .v-select__slot {font-size:14px;}
.g-select.v-select >>> .v-icon.arrow_down {width: 24px;height: 24px;object-fit: cover;background: url('~@/assets/icon/icon-24-positive-chevron-down.svg') no-repeat center center;background-size: contain;}
.theme--dark .g-select.v-select >>> .v-icon.arrow_down {background: url('~@/assets/icon/icon-24-positive-chevron-down_dark.svg') no-repeat center center;}
.g-select.v-text-field--outlined.v-input--dense.v-text-field--single-line >>> .v-input__control > .v-input__slot, .g-select.v-text-field--outlined.v-input--dense.v-text-field--outlined >>> .v-input__control > .v-input__slot {min-height: 36px;}
.g-select.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__prepend-outer,
  .g-select.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__prepend-inner,
  .g-select.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__append-inner,
  .g-select.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__append-outer,
  .g-select.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__prepend-outer,
  .g-select.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__prepend-inner,
  .g-select.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__append-inner,
  .g-select.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined >>> .v-input__append-outer {
  margin-top: 6px;
}

.g-select.v-text-field:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::before {border-color: #cecece;/*bottom: 0px;*/}
.g-select.v-text-field:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::before {border-color: #3ba8be;}
.g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::before,
.g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::after,
.g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::before,
.g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::after {border-color: #3ba8be;/*bottom: 0px;*/}
.g-select.v-text-field.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot::before,
.g-select.v-text-field.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot::after {border-color: #b71c1c!important;border-top-width: 1px;}
.g-select.v-text-field.v-input--is-focused.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot::before,
.g-select.v-text-field.v-input--is-focused.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot::after,
.g-select.v-text-field.v-input--is-focused.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot:hover::before,
.g-select.v-text-field.v-input--is-focused.error--text:not(.v-text-field--outlined) >>> .v-input__control .v-input__slot:hover::after {border-color: #b71c1c!important;border-top-width: 1.5px;/*bottom: 0px;*/}

.theme--dark .g-select.v-text-field:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::before {border-color: #363d44;/*bottom: 0px;*/}
.theme--dark .g-select.v-select >>> .v-select__selection--disabled {color: #d9dee4 !important;}
.theme--dark .g-select.v-text-field--solo >>> .v-input__control > .v-input__slot:hover,
  .theme--dark .g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot:hover fieldset,
  .theme--dark .g-select.v-text-field--solo.v-input--is-focused >>> .v-input__control > .v-input__slot,
  .theme--dark .g-select.v-text-field--outlined.v-input--is-focused >>> .v-input__control > .v-input__slot fieldset,
  .theme--dark .g-select.v-text-field:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::before,
  .theme--dark .g-select.v-text-field:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::before,
  .theme--dark .g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::before,
  .theme--dark .g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot::after,
  .theme--dark .g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::before,
  .theme--dark .g-select.v-text-field.v-input--is-focused:not(.v-text-field--outlined):not(.error--text) >>> .v-input__control .v-input__slot:hover::after {border-color: #2373c4 !important;}

.theme--dark .g-select.v-text-field--outlined >>> .v-input__control > .v-input__slot:hover .v-label.v-label--active,
  .theme--dark .g-select.v-input--is-focused.v-text-field--outlined >>> .v-input__control > .v-input__slot .v-label.v-label--active,
  .theme--dark .g-select.v-text-field:not(.error--text) >>> .v-input__control:hover .v-select__slot .v-label,
  .theme--dark .g-select.v-text-field.v-input--is-focused:not(.error--text) >>> .v-select__slot .v-label {color:#2373c4 !important;}

.g-select.v-select.v-text-field--placeholder.v-select--is-multi >>> input::placeholder { color: #444; }
</style>
